import React from "react";
import Slide from "react-reveal/Slide";
import "./Aboutme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

const AboutMe = () => {
  return (
    <section className="features-service min-h-screen flex justify-center  flex-col" id="aboutMe">
      <div className="container">
      <h1 className="text-5xl font-dosis font-bold mt-2 aboutMeName">About-Me</h1>
        <div className="row">
          <Slide bottom>
            <div className="col-md-5 text-2xl  mt-5">
              <p>
                <span className="info-name">Name:</span> Md.Osman Faruk
              </p>
              <p>
                <span className="info-name">Age:</span> 17
              </p>
              <p>
                <span className="info-name">Nationality:</span> Bangladesh
              </p>
              <p>
                <span className="info-name">Language:</span> Bangla, English
              </p>
              <p>
                <span className="info-name">Date Of Birth:</span> 4 April, 2004
              </p>
              <p>
                <span className="info-name">Email:</span>{" "}
                osmanfaaruk@gmail.com
              </p>
              <p>
                <span className="info-name">Phone:</span> +880 01841483138
              </p>
              <div className="mt-2">
                <a href={`https://github.com/usmanfaroqq`}>
                  <FontAwesomeIcon className="media-icon" icon={faGithub} />
                </a>
                <a href={`https://www.linkedin.com/in/usmanfaroqq/`}>
                  <FontAwesomeIcon
                    className="media-icon ms-3"
                    icon={faLinkedinIn}
                  />
                </a>
                <a href={`https://twitter.com/usmanfaroqq`}>
                  <FontAwesomeIcon
                    className="media-icon ms-3"
                    icon={faTwitter}
                  />
                </a>
              </div>
            </div>
          </Slide>
          <Slide right>
            <div className="col-md-7 font-dosis text-2xl">
              <p className="text-secondary my-5 font-dosis  ">
                I've always enjoyed programming. JavaScript and python are my
                most favorite programming language. I love to work on a team
                project, and I am very good at communication, leadership, and
                Research. I am always couriers to learn new things.
                Specifically, when it is about programming I become more
                curious. I love to explore new things.
              </p>
              <button className="btn btn-outline-success">
                <a
                  href={`https://drive.google.com/file/d/1pR_NcHGGCVdh33bLl1ZRiYfZmGOjTaKU/view?usp=sharing`}
                  download="Md.Osman Faruk Resume"
                >
                  Download Resume
                </a>
              </button>
            </div>
          </Slide>
        </div> 
           <div className="mt-5">
            <h1 className="aboutMeName text-2xl font-dosis">My Skills At Core Technologies</h1>
            <p>JavaScript</p>
           <div className="progress">
          <div
            className="progress-bar bg-warning"
            role="progressbar"
            style={{ width: "50%" }}
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >50%</div>
        </div>
        <br />
        TypeScript
        <div className="progress">
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: "15%" }}
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >15%</div>
        </div>
        <br />
        React
        <div className="progress">
          <div
            className="progress-bar bg-success"
            role="progressbar"
            style={{ width: "60%" }}
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >60%</div>
        </div>   
        <br />
        Node.js
        <div className="progress">
          <div
            className="progress-bar bg-warning"
            role="progressbar"
            style={{ width: "45%" }}
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >45%</div>
        </div>
        <br />
        Redux
        <div className="progress">
          <div
            className="progress-bar bg-warning"
            role="progressbar"
            style={{ width: "50%" }}
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >50%</div>
        </div>   
        <br />
            Css
            <div className="progress">
          <div
            className="progress-bar bg-success"
            role="progressbar"
            style={{ width: "55%" }}
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >55%</div>
        </div>   
        <br />
            Sass
            <div className="progress">
          <div
            className="progress-bar bg-warning"
            role="progressbar"
            style={{ width: "50%" }}
            aria-valuenow="25"
            aria-valuemin="0"
            aria-valuemax="100"
          >50%</div>
        </div>   
            </div> 
      </div>
    </section>
  );
};

export default AboutMe;
